import React, { useState, useMemo, useContext } from "react";
import qs from "query-string";

import { useLocation } from "react-router-dom";

import { createContext } from "react";
import moment from "moment";
import useSelectedChannels from "./hooks/PrepareDataHooks/useSelectedChannels";
import useSavedLocation from "./hooks/PrepareDataHooks/useSavedLocation";
import useChannels from "./hooks/PrepareDataHooks/useChannels";
import useEventsToDisplay from "./hooks/PrepareDataHooks/useEventToDisplay";
import useSyncCoordinateQueries from "./hooks/PrepareDataHooks/useSyncCoordinateQueries";

import usePosition from "./usePosition";

const GlobalAppContext = createContext({});

function getDataRange(initialState, today) {
  return {
    startDate:
      initialState.startDate ||
      parseInt(
        moment(today)
          .subtract(2, "months")
          .format("X")
      ),
    endDate:
      initialState.endDate ||
      parseInt(
        moment(today)
          .add(2, "months")
          .format("X")
      ),
  };
}

export function _usePrepareData() {
  const location = useLocation();
  const initialState = useMemo(() => qs.parse(location.search), [location.search]);
  const today = useMemo(() => moment().format(), []);

  const [bounds, setBounds] = useState(null);

  const [dateRange, setDateRange] = useState(getDataRange(initialState, today));
  const [savedLocation, savedLocationLoading, reloadSavedLocation] = useSavedLocation();
  const [channels, channelsAreLoading] = useChannels();
  const { userPosition, userPosLoading } = usePosition();

  const [
    toggleChannel,
    selectedChannels,
    selectOrDeselectAll,
    areAllChannelsSelected,
  ] = useSelectedChannels({
    savedLocation,
    savedLocationLoading,
    channels,
    channelsAreLoading,
    initialState,
  });
  const [
    setUpdateEvents,
    updateEvents,
    setCheckedOnlyFavs,
    isLoadingEvents,
    filteredEvents,
    checkedOnlyFavs,
    setFilteredEvents,
  ] = useEventsToDisplay(dateRange, selectedChannels, bounds);

  const query = useSyncCoordinateQueries({ bounds, dateRange, selectedChannels });

  const result = useMemo(
    () => ({
      userPosition,
      userPosLoading,
      channels,
      query,
      selectedChannels,
      bounds,
      filteredEvents,
      savedLocation,
      reloadSavedLocation,
      setFilteredEvents,
      setCheckedOnlyFavs,
      checkedOnlyFavs,
      toggleChannel,
      setBounds,
      isLoading: isLoadingEvents,
      isLoadingEvents,
      today,
      dateRange,
      setDateRange,
      setUpdateEvents,
      updateEvents,
      selectOrDeselectAll,
      areAllChannelsSelected,
      savedLocationLoading,
    }),
    [
      userPosition,
      userPosLoading,
      channels,
      query,
      selectedChannels,
      bounds,
      filteredEvents,
      savedLocation,
      reloadSavedLocation,
      setFilteredEvents,
      setCheckedOnlyFavs,
      checkedOnlyFavs,
      toggleChannel,
      setBounds,
      isLoadingEvents,
      today,
      dateRange,
      setDateRange,
      setUpdateEvents,
      updateEvents,
      selectOrDeselectAll,
      areAllChannelsSelected,
      savedLocationLoading,
    ]
  );
  return result;
}

export function DataProvider({ children }) {
  const data = _usePrepareData();
  return <GlobalAppContext.Provider value={data}>{children}</GlobalAppContext.Provider>;
}

export function usePrepareData() {
  return useContext(GlobalAppContext);
}
